import Enumerator from './Enumerator';

export const yesNoOptions = ['none', 'yes', 'no', 'yes_discharged', 'not_important', 'unsure'];

export class YesNoOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
      case 'b2':
        correctOption = 'yes';
        break;
      case '2':
      case 'b1':
        correctOption = 'no';
        break;
      case 'b3':
        correctOption = 'yes_discharged';
        break;
      case '3':
        correctOption = 'not_important';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

YesNoOption.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  yes: {
    get title() {
      return 'Yes';
    }
  },
  no: {
    get title() {
      return 'No';
    }
  },
  yes_discharged: {
    get title() {
      return 'Yes - discharged';
    }
  },
  not_important: {
    get title() {
      return 'Not important';
    }
  },
  unsure: {
    get title() {
      return 'Unsure';
    }
  }
});

export default {
  yesNoOptions,
  YesNoOption
};
